import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getRequest } from '../../globalhelper/helper';
import '../CI/COD.css';
import VR2_Forms from '../../pages/VR2_Form_Rendering/displayContainer';
import ReactSelect from 'react-select';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Alert, AlertTitle, Autocomplete, Box, Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { CSVLink } from 'react-csv';
import { GetApp } from '@material-ui/icons';
const ItemMaster_Search = props => {
  const [state, setState] = useState({
    showtable: false,
    formData: {
      preferredvendor: '',
      itemname: '',
      itemid: '',
      status: '',
      period: null
    },
    tableData: [],
    displayData: [],
    dropdown_preferredvendor: [],
    dropdown_itemname: [],
    dropdown_itemid: [],
    dropdown_status: [],
    redirect: false,
    SearchJSON: []
  });
  useEffect(() => {
    sessionStorage.setItem('pageName', 'Search ItemMaster');
    getRequest(`api/edureka/getIM1`).then(res => {
      let temp = JSON.parse(res.res.data);
      let temp1 = temp?.map(value => value['Preferred Vendor']);
      let temp2 = temp1?.filter(value => value)?.sort((a, b) => a.localeCompare(b));
      let temp3 = temp?.map(value => value['Item Name']);
      let temp4 = temp3?.filter(value => value);
      let tem = [...new Set(temp4)]?.sort((a, b) => a.localeCompare(b));
      let temp7 = temp?.map(value => value['Item ID']);
      let temp8 = temp7?.filter(value => value)?.sort((a, b) => a.localeCompare(b));
      setState(prevState => ({
        ...prevState,
        dropdown_preferredvendor: temp2,
        dropdown_itemname: tem,
        dropdown_itemid: temp8
      }));
    });
  }, []);
  const handleChange = e => {
    const NAME = e.target.name,
      VALUE = e.target.value;
    setState(prevState => ({
      ...prevState,
      formData: {
        ...prevState.formData,
        [NAME]: VALUE || ''
      }
    }));
  };
  const handleSelectChange = (name, value) => {
    setState(prevState => ({
      ...prevState,
      formData: {
        ...prevState.formData,
        [name]: value || ''
      }
    }));
  };
  useEffect(() => {
    if (!state.formData.period) return;

    // if your period is '2025-10'
    const startDate = moment(state.formData.period, 'YYYY-MM').startOf('month');
    const endDate = moment(state.formData.period, 'YYYY-MM').endOf('month');
    const filtered = state.tableData.filter(item => {
      // parse with correct format (DD/MM/YYYY)
      const itemDate = moment(item?.['Created At'], ['YYYY-MM-DDTHH:mm:ss.SSSZ', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD', 'DD/MM/YYYY'], true);
      return itemDate.isSameOrAfter(startDate) && itemDate.isSameOrBefore(endDate);
    });
    // console.log(filtered)

    setState(prev => ({
      ...prev,
      displayData: filtered
    }));
  }, [state.formData.period, state.tableData]);
  const handleSearch = () => {
    const {
      itemname,
      itemid,
      status
    } = state.formData;
    getRequest(`api/edureka/getIMSearch?itemname=${itemname}&itemid=${itemid}&status=${status}`).then(res => {
      if (res.res.status === 'success') {
        let temp = JSON.parse(res.res.data);
        console.log(temp);
        setState(prevState => ({
          ...prevState,
          tableData: temp,
          showtable: true,
          displayData: temp
        }));
      } else {
        console.log('No Data');
      }
    });
  };
  const handleReset = () => {
    setState(prevState => ({
      ...prevState,
      showtable: false,
      formData: {
        preferredvendor: '',
        itemid: '',
        itemname: '',
        status: ''
      }
    }));
  };
  const handleItemMaster = i => {
    console.log(i)
    const itemid = i['Item ID']
    localStorage.setItem('api', `api/edureka/getIMUpdatedJSON?itemid=${itemid}`)
    window.open(
      `/Dynamic_Forms?token=ItemMaster&action=edit&orgId=NoLDE&docId=${itemid}`,
      '_blank'
    )
    // getRequest(`api/edureka/getIMUpdatedJSON?itemid=${itemid}`).then(res => {
    //   if (res.res.status === 'success') {
    //     console.log(res.res.data)

    //     setState(prevState => ({
    //       ...prevState,
    //       SearchJSON: res.res.data,
    //       redirect: true
    //     }))
    //   } else {
    //     console.log('No Data')
    //   }
    // })
  }
  const onBack = () => {
    setState(prevState => ({
      ...prevState,
      redirect: false,
      SearchJSON: []
    }))
  }
  return <>
    <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel3-content' id='panel3-header'>
        <Typography variant='h6'>Search Item Master</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={3}>
          <Grid item xs={1} sm={2} md={3}>
            <Autocomplete value={state.dropdown_itemname.find(option => option === state.formData.itemname) || ''} onChange={(e, newValue) => handleSelectChange('itemname', newValue)} options={state.dropdown_itemname} renderInput={params => <TextField name='itemname' {...params} label='Item Name' variant='outlined' size='small' fullWidth />} />
          </Grid>
          <Grid item xs={1} sm={2} md={3}>
            <Autocomplete value={state.dropdown_itemid.find(option => option === state.formData.itemid) || ''} onChange={(e, newValue) => handleSelectChange('itemid', newValue)} options={state.dropdown_itemid} renderInput={params => <TextField name='itemid' {...params} label='Item ID' variant='outlined' size='small' fullWidth />} />
          </Grid>
          <Grid item xs={1} sm={2} md={3}>
            <Autocomplete fullWidth options={['Active', 'Inactive', 'Not Released', 'Rejected', 'Void', 'Waiting For Approval']} value={state.formData.status} onChange={(event, newValue) => {
              handleSelectChange('status', newValue);
            }} renderInput={params => <TextField name='status' {...params} label='Status' variant='outlined' size='small' fullWidth />} />
          </Grid>
          <Grid item xl={1}>
            <Button variant='contained' color='primary' onClick={handleSearch}>
              Search
            </Button>
          </Grid>
          <Grid item xl={1}>
            <Button variant='contained' color='error' onClick={handleReset}>
              Reset
            </Button>
          </Grid>
          <Grid item xl={1}>
            <Button variant='contained' color='warning' onClick={() => props.onBack()}>
              Back
            </Button>
          </Grid>
        </Grid>
        {state.displayData.length > 0 && <>
          <Typography variant='h6' mt={2}>
            Filter
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={1} sm={2} md={3}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker label='Period' value={state.formData.period} views={['month', 'year']} onChange={newValue => {
                  handleSelectChange('period', newValue);
                }} renderInput={params => <TextField fullWidth size='small' {...params} />} />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </>}
      </AccordionDetails>
    </Accordion>

    <br />

    {state.showtable && state.tableData.length > 0 ? <>
      <Box align='right'>
        <Button color='success' variant='contained'>
          <CSVLink style={{
            color: 'white',
            textDecoration: 'none'
          }} data={state.tableData} filename='Item_Master.csv'>
            <GetApp />
          </CSVLink>
        </Button>
      </Box>
      <TableContainer component={Paper}>
        <Table sx={{
          minWidth: 650
        }} aria-label='simple table'>
          <TableHead>
            <TableRow>
              {(state.displayData.sort((a, b) => a['Item ID'].localeCompare(b['Item ID'])) && state.displayData.sort((a, b) => a['Item ID'].localeCompare(b['Item ID'])).length > 0 ? Object.keys(state.displayData.sort((a, b) => a['Item ID'].localeCompare(b['Item ID']))[0] || {}) : []).map((key, index) => <TableCell key={index} sx={{
                textAlign: 'left'
              }}><b>{key}</b></TableCell>)}
            </TableRow>
          </TableHead>
          <TableBody>
            {(state.displayData &&
              state.displayData
                .sort((a, b) => a['Item ID'].localeCompare(b['Item ID']))
                .map((item, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell>
                        <Button
                          variant='text'
                          color='primary'
                          onClick={() => handleItemMaster(item)}
                        >
                          {item['Item ID']}
                        </Button>
                      </TableCell>
                      <TableCell>{item['Item Name']}</TableCell>
                      <TableCell>{item.Rate}</TableCell>
                      <TableCell>{item['Preferred Vendor']}</TableCell>
                      <TableCell>{item['Commodity Code']}</TableCell>
                      <TableCell>
                        {moment(item['Created At']).format('DD/MM/YYYY')}
                      </TableCell>
                      <TableCell>{item['Status']}</TableCell>
                    </TableRow>
                  )
                })) || (
                <TableRow>
                  <TableCell colSpan={7}>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%'
                      }}
                    >
                      <Alert severity='error' variant='outlined'>
                        No matching records found. Please adjust your search criteria.
                      </Alert>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
    </> : state.showtable && <Box sx={{
      margin: 'auto'
    }}>
      <Alert severity='warning'>
        <AlertTitle>No Data Found</AlertTitle>
        There is no data to display at the moment.
      </Alert>
    </Box>}
  </>;
};
const mapStateToProps = state => ({
  userData: state.login.userData
})

export default connect(mapStateToProps)(ItemMaster_Search)